<template>
    <div>
        <md-empty-state
            md-icon="input"
            md-label="Explore the power of HiCognition"
            md-description=""
            class="test"
            style="width:50%; "
        >
            <p style="text-align: justify;">
                This is the public version of HiCognition. The aim is getting you started as fast as possible.
            </p>
            <p style="text-align: justify;">
                We have prepared a couple of datasets for you and preprocessed
                all the data to reproduce the figures from the HiCognition
                manuscript (see the table below).
            </p>
            <md-table>
                <md-table-row>
                    <md-table-head>Task</md-table-head>
                    <md-table-head>Figure</md-table-head>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjoxfQ.nijHQkLPTI69r8AWNAWSo5I8nIJNYhj7WuTJnfhL2RnqPGtxaSDnr86vFgg22jnrh8pMPv2dVctIOKFPb3J-vA&sessionID=1"
                        >
                            Explore average profiles
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjoxfQ.nijHQkLPTI69r8AWNAWSo5I8nIJNYhj7WuTJnfhL2RnqPGtxaSDnr86vFgg22jnrh8pMPv2dVctIOKFPb3J-vA&sessionID=1"
                        >
                            (Figure 2a)
                        </a>
                    </md-table-cell>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjozfQ.8q7TZ79ky7Th63oMqhSN949YVOcAe-JHTOfnlbpEgyLY-9YqbUq2XnEP_AbsmfeU3ENiWh_mS7adCNqPpoHqUQ&sessionID=3"
                        >
                            Explore average profiles and heterogeneity
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjozfQ.8q7TZ79ky7Th63oMqhSN949YVOcAe-JHTOfnlbpEgyLY-9YqbUq2XnEP_AbsmfeU3ENiWh_mS7adCNqPpoHqUQ&sessionID=3"
                        >
                            (Figure 2b)
                        </a>
                    </md-table-cell>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo0fQ.1h6NS1UE78R2HNIovjkJ1xMt6J0I5pxAwyraqUH3Y-XJljFdqJh52FN3FN3zy3FazEBhTE8xRqaqJragMp2OUw&sessionID=4"
                        >
                            Explore average profiles
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo0fQ.1h6NS1UE78R2HNIovjkJ1xMt6J0I5pxAwyraqUH3Y-XJljFdqJh52FN3FN3zy3FazEBhTE8xRqaqJragMp2OUw&sessionID=4"
                        >
                            (Figure 2c-f)
                        </a>
                    </md-table-cell>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo1fQ.-w8somIo9RoI28wOuWjYHKNjjlBTjkcFBy1gGsEy-Tts_Q1fU6fHhLRouI1L632tLiN4bxAgFXg4z8tlyRjqcQ&sessionID=5"
                        >
                            Exploring heterogeneity
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo1fQ.-w8somIo9RoI28wOuWjYHKNjjlBTjkcFBy1gGsEy-Tts_Q1fU6fHhLRouI1L632tLiN4bxAgFXg4z8tlyRjqcQ&sessionID=5"
                        >
                            (Figure 3a-b)
                        </a>
                    </md-table-cell>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo2fQ.py_60nPfFnLx4bOpr1HBf-SmjQI5WtTRxgSyAw_sliYe8jodsdFdguTVLtLKy7sltb93X1ZHfbt3-150jyke4A&sessionID=6"
                        >
                            Explore average profiles and associations
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo2fQ.py_60nPfFnLx4bOpr1HBf-SmjQI5WtTRxgSyAw_sliYe8jodsdFdguTVLtLKy7sltb93X1ZHfbt3-150jyke4A&sessionID=6"
                        >
                            (Figure 3c-d)
                        </a>
                    </md-table-cell>
                </md-table-row>
                <md-table-row>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo3fQ.7L7lDDSXuZqBDUtlRl6X6uSO9y5uru9BF6_JNOjtDsMNSEtolMA3tIWev9JVYWZ4ucZlWPgpkRthCSw4a7yeFg&sessionID=7"
                        >
                            Validating associations in Figure 3c-d
                        </a>
                    </md-table-cell>
                    <md-table-cell>
                        <a
                            href="#/main/session?sessionToken=eyJhbGciOiJIUzUxMiJ9.eyJzZXNzaW9uX2lkIjo3fQ.7L7lDDSXuZqBDUtlRl6X6uSO9y5uru9BF6_JNOjtDsMNSEtolMA3tIWev9JVYWZ4ucZlWPgpkRthCSw4a7yeFg&sessionID=7"
                        >
                            (Figure 3e-f)
                        </a>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <p style="text-align: justify;">
                If you want to explore datasets on your own, use the data form the manuscript, upload your own data or click on the plus at the bottom right to start creating a visualization.
            </p>
            <!-- md-icon="../../static/logo.svg" -->
            <!-- <img v-bind:src="'../../static/logo.svg'"> -->
        </md-empty-state>
    </div>
</template>

<script>
export default {
    name: "EmptyStateBasic",
    data: function() {
        return {
            //isDemo: process.env.SHOWCASE
        };
    }
};
</script>

<style scoped>
.md-empty-state {
    max-width: 5000px !important;
    /* color: red; */
}
.md-table-row {
    text-align: justify;
    /* color: red; */
}
</style>



// WEBPACK FOOTER //
// src/components/ui/emptyState.vue